const store = {
  _imagemJornal: [],

  get imagemJornal() {
    return this._imagemJornal;
  },

  adicionaImagem(imageName, imagem) {
    this._imagemJornal.push({ imageName: imageName, imagem: imagem });
  },

  removeImagem(indice) {
    this._imagemJornal.pop(indice);
  },

  alteraImagem(index, imageName, image) {
    this._imagemJornal[index].imageName = imageName;
    this._imagemJornal[index].imagem = image;
  },

  limpaStore() {
    this._imagemJornal.slice(0, this._imagemJornal.length);
  }
};
export default store;
